
import { io } from 'socket.io-client';
import config from '../config';


let socket = null;

export const connectSocket = ({
  access_token,
  user_id,
}) => {
  /*
   * Reuse the existing socket.
   * Reconnect it when it exists but is disconnected.
   */
  if (socket) {
    if (!socket.connected) {
      socket.auth = {
        access_token,
        user_id,
      };

      socket.connect();
    }

    return socket;
  }


  /*
   * Create the socket instance immediately.
   */
  socket = io(
    // "https://blackbox-core-7bkvt.ondigitalocean.app", // production
    config.apiBASEURL, // local: http://localhost:8080
    {
      transports: ["websocket"],

      autoConnect: false,

      auth: {
        access_token,
        user_id,
      },
    }
  );

  /*
   * Register listeners before connecting.
   */
  socket.on("connect", () => {
    console.log(
      "🔌 Socket connected:",
      socket?.id
    );
  });

  socket.on("disconnect", (reason) => {
    console.log(
      "👋 Socket disconnected:",
      reason
    );
  });

  socket.on("connect_error", (error) => {
    console.error(
      "❌ Connection error:",
      error.message
    );
  });

  socket.connect();

  return socket;
};

export const disconnectSocket = () => {
  if (!socket) {
    return;
  }

  socket.removeAllListeners();
  socket.disconnect();

  console.log(
    "🚫 Socket manually disconnected"
  );

  socket = null;
};

export const getSocket = () => socket;